"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DataTable = require("./DataTable");
Object.keys(_DataTable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DataTable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DataTable[key];
    }
  });
});